import React, { useEffect } from "react";
import {
  StyledWrap,
  StyledList,
  StyledListItem,
  StyledButton,
  StyledHeading,
  StyledType,
  StyledLink,
  StyledFooter,
  StyledContent,
} from "./_.styled";
import { Type } from "discover.medical.react-component-library";
import { useDispatch, useStore } from "../../store";
import { fetchCounterInfo } from "../../store/actions/counter";
import { fetchUserInfo } from "../../store/actions/userInfo";
import { Link } from "react-router-dom";
import useCreateLinkComponent from "../../hooks/useCreateLinkComponent";
import ErrorBoundary from "../ErrorBoundary";

export const fetchData = async (dispatch) => {
  const userInfo = await fetchUserInfo(dispatch);
  const shouldFetchCounter = userInfo?.isPersonalized && userInfo?.isCeReadUser;

  if (shouldFetchCounter) {
    fetchCounterInfo(dispatch);
  }
};

export const CEHomeWidgetDHE = () => {
  const {
    counter: { available, claimed, isFetching: isCounterFetching },
    userInfo: { isCeReadUser, isPersonalized, isFetching: isUserFetching },
  } = useStore();
  const dispatch = useDispatch();
  const CEButton = useCreateLinkComponent(StyledButton);

  useEffect(() => {
    fetchData(dispatch);
  }, [dispatch]);

  if (isUserFetching || isCounterFetching) {
    return (
      <ErrorBoundary team="cd.ghostriders">
        <StyledWrap data-testid="continuing-education-loader">
          Loading...
        </StyledWrap>
      </ErrorBoundary>
    );
  }

  if (isPersonalized && !isCeReadUser) return null;

  return (
    <ErrorBoundary team="cd.ghostriders">
      <StyledWrap data-testid="continuing-education">
        {isPersonalized ? (
          <>
            <StyledHeading
              element="h2"
              color="gray800"
              fontFamily="secondary"
              data-testid="continuing-education-my-ce"
            >
              My CE
            </StyledHeading>
            <StyledList type="ul">
              <StyledListItem>
                Available Contact Hours
                <StyledType element="span" fontWeight="bold" color="gray800">
                  {" "}
                  {available}
                </StyledType>{" "}
                hr
              </StyledListItem>
              <StyledListItem>
                Claimed Contact Hours
                <StyledType element="span" fontWeight="bold" color="gray800">
                  {" "}
                  {claimed}
                </StyledType>{" "}
                hr
              </StyledListItem>
            </StyledList>
            <Link to="/ce/available" component={CEButton} kind="outlined">
              View More
            </Link>
          </>
        ) : (
          <>
            <StyledHeading
              element="h2"
              color="gray800"
              fontFamily="secondary"
              data-testid="continuing-education-create-account"
            >
              Continuing Education
            </StyledHeading>
            <StyledContent>
              <StyledLink href="/dha?action=register&returnToUrl=/">
                Create a FREE user account
              </StyledLink>{" "}
              and{" "}
              <Type element="strong" color="gray800">
                earn contact hours
              </Type>{" "}
              for using Dynamic Health.
            </StyledContent>
            <StyledFooter>
              Have an account?{" "}
              <StyledLink href="/dha?returnToUrl=/">Sign in</StyledLink>
            </StyledFooter>
          </>
        )}
      </StyledWrap>
    </ErrorBoundary>
  );
};

export default CEHomeWidgetDHE;
